import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './TrustAndVerification.css';
import { Grid, Row, Col } from 'react-bootstrap';
import cx from 'classnames';

// Components
import TrustItems from '../../components/Trust/TrustItems';
import EditProfileSideMenu from '../../components/EditProfileSideMenu';
import Loader from '../../components/Loader';
import { inject, observer } from 'mobx-react';

@inject('userStore')
@observer
class TrustAndVerification extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getUserVerifiedInfo: PropTypes.object,
    }),
    account: PropTypes.shape({
      userId: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    data: {
      loading: true,
    },
  };

  render() {
    const {
      title,
      userStore: { loading },
    } = this.props;
    return (
      <div className={s.container}>
        <Grid>
          <Row className={cx(s.landingContainer)}>
            <Col xs={12} sm={2} md={2} lg={2} className={s.smPadding}>
              <EditProfileSideMenu />
            </Col>
            <Col xs={12} sm={9} md={9} lg={9} className={s.smPadding}>
              {loading && <Loader type={'text'} />}

              {!loading && <TrustItems />}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapState = state => ({
  account: state.account.data,
});

const mapDispatch = {};

export default compose(
  withStyles(s),
  connect(
    mapState,
    mapDispatch,
  ),
)(TrustAndVerification);



// WEBPACK FOOTER //
// ./src/routes/trustAndVerification/TrustAndVerification.js